/**
 * Note: all of this code is copied from my personal open source repo:
 * https://github.com/psenger/react-static-config-loader
 */
import React, { createContext, useEffect, useState } from "react";

interface StaticConfigWrapperProps {
  loader: () => Promise<any>;
  loadingMsg?: string;
  children?: React.ReactNode;
}

export type ConfigPropExtenderHocProps = {
  propName: string | "config";
  children: JSX.Element;
};

const Context: any = createContext<any>(null);

export class ConfigPropExtenderHoc extends React.Component<
  ConfigPropExtenderHocProps
> {
  static contextType = Context;

  constructor(props: any, context: any) {
    super(props, context);
  }

  render() {
    const propName = this.props?.propName || "config";
    return React.cloneElement(this.props.children, {
      [propName]: this.context
    });
  }
}

export const StaticConfigWrapper = ({
  children,
  loader,
  loadingMsg
}: StaticConfigWrapperProps) => {
  const [config, setConfig] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);

  const useComponentDidMount = (onMountHandler: () => Promise<void>) => {
    useEffect(() => {
      async function asyncOnMountHandler() {
        await onMountHandler();
      }
      asyncOnMountHandler();
    }, []);
  };

  useComponentDidMount(async () => {
    try {
      setIsLoading(true);
      const data = await loader();
      setConfig(data);
    } finally {
      setIsLoading(false);
    }
  });

  const { Provider, Consumer } = Context;

  return (
    <>
      <Provider value={config}>
        <Consumer>{() => (isLoading ? loadingMsg : children)}</Consumer>
      </Provider>
    </>
  );
};
